export const sendMetrik = (type, value) => {
  window.ym(102057666, type, value);
}